import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '@/redux/helper';

// eslint-disable-next-line import/prefer-default-export
export const selectIsGuestSessionLocked = createSelector(
  (state: AppState) => state.user.logged,
  (state: AppState) => state.deviceSettings.guestSessionLockUntil,
  (_: unknown, now: number | null) => now ?? Date.now(),
  (logged, guestSessionLockUntil, now) => !logged && guestSessionLockUntil && guestSessionLockUntil > now,
);
